import update from 'immutability-helper';
import { ActionTypes, RootStore } from './types';

export const reducer = (state: RootStore, action: ActionTypes): RootStore => {
  switch (action.type) {
    case '@STORE/START_LOADING': {
      const { key, params } = action.payload;
      const newState = {
        ...state,
      };
      newState[key] = {
        ...state[key],
        loading: true,
        error: undefined,
        params,
      };
      return newState;
    }

    case '@STORE/STOP_LOADING': {
      const { key, params } = action.payload;
      const newState = {
        ...state,
      };
      newState[key] = {
        ...state[key],
        loading: false,
        error: undefined,
        params,
      };
      return newState;
    }

    case '@STORE/SET_VALUE': {
      const { key, data, params } = action.payload;
      const newState = {
        ...state,
      };
      newState[key] = {
        ...state[key],
        loading: false,
        data,
      };

      if (params) {
        newState[key].params = params;
      }

      return newState;
    }

    case '@STORE/UPDATE_VALUE': {
      const { key, propName, data } = action.payload;

      const newState = update(state, {
        [key]: {
          data: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $apply: (currentData: any) => {
              return { ...currentData, [propName]: data };
            },
          },
          loading: { $set: false },
        },
      });

      return newState;
    }

    case '@STORE/SET_ERROR': {
      const { key, error } = action.payload;
      const newState = {
        ...state,
      };
      newState[key] = {
        ...state[key],
        loading: false,
        error,
      };
      return newState;
    }

    case '@STORE/CLEAR': {
      const { key, data } = action.payload;
      const newState = {
        ...state,
      };
      newState[key] = {
        key,
        error: undefined,
        loading: false,
        data,
        params: undefined,
      };
      return newState;
    }

    case '@STORE/WIPE': {
      const newState = { ...action.payload.initialState };
      return newState;
    }

    default:
      return state;
  }
};

export default reducer;
